import { atom } from "../editor-jotai";

import type { RecordingState } from "./types";

const DEFAULT_CAMERA_SIZE = 180;

const DEFAULT_RECORDING_STATE: RecordingState = {
  status: "idle",
  settings: {
    cameraDeviceId: "",
    micDeviceId: "",
    cameraShape: "rounded-square",
    immersiveMode: true,
    cameraEnabled: true,
    micEnabled: true,
    cameraMirrored: true,
    backgroundBlur: false,
  },
  cameraPosition: { x: -1, y: -1 },
  cameraSize: DEFAULT_CAMERA_SIZE,
  elapsedSeconds: 0,
};

export const recordingStateAtom = atom<RecordingState>(DEFAULT_RECORDING_STATE);

export const recordingStatusAtom = atom<RecordingState["status"]>((get) => {
  return get(recordingStateAtom).status;
});
